import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const TRAILER_HOME = {
  nickname: 'PRODUCTS.TRAILER_HOME.shortname',
  properties: [
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.pattern(/^\d+$/)
      ]]
    },
    {
      name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      TRAILER_HOME: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^([a-zA-Z]{2}\d{4,5})$/)
      ]]
    },
    {
      name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      SUM_INSURED_THOUSANDS_ONLY: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^(?:[1-9]\d*)000$/)
      ]],
    },
    {
      name: 'vehicleRentalCarCover', key: 'RENTAL_CAR_COVER_KOLIBRI', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'isTrailerStationary', key: 'IS_TRAILER_STATIONARY', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.4', value: '4000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.6', value: '6000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.8', value: '8000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' }
        ]
      }
    },
    {
      name: 'contentsSumInsured', key: 'HOUSE_CONTENT_SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.30', value: '30000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.50', value: '50000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.100', value: '100000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.150', value: '150000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.200', value: '200000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.250', value: '250000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_CONTENT_SUM_INSURED.300', value: '300000' }
        ]
      }
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
        ]
      }
    },
  ],
  icon:'trailer-home'
};
